







































































































































































import { Component, Model, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import VueSlider from "vue-slider-component";
import Scoring from '@/store/modules/Scoring';
import { ApexChartOptions, HistogramChartOptions, BarChartOptions } from '@/api/model/ApexChartOptions';
import BarChart from '@/components/chart/BarChart.vue';
import { CHART_TYPES, CHART_TYPE_NAMES } from '@/utils/ChartTypes';
import Modelling from '@/store/modules/Modelling';
import { getModule } from 'vuex-module-decorators';
import Decisions from '@/store/modules/Decisions';
import Viewpoints from '@/store/modules/Viewpoints';

const modellingModule = getModule(Modelling);
const decisionsModule = getModule(Decisions);
const viewpointModule = getModule(Viewpoints);


@Component({
    components: {VueSlider, BarChart}
})
export default class LinearScoringDefinitionRuleCreator extends Vue {

    @Model()
    scoringRules!: any[];

    @Prop()
    scoringKeys!: any[];

    @Prop()
    values!: number[];

    @Prop()
    prefix!: string;

    @Prop()
    suffix!: string;

    @Prop()
    tab: number

    @Prop({ default: '', type: String })
    factorId!: string;



    private chartData = {
    data: {
        series: [],
    },
    title: {
        text: '',
    },
    xaxis: {
        categories: [],
    },
    };
    get factors() {
    return modellingModule.publishedModelFactorResources;
}
    private sliderOptions = [
        {disabled: true,},
        {disabled: false,}]

    private endSliderOptions = [
        {disabled: true,},
        {disabled: true,}]

    private rules = {
        number: (value) => typeof value==='number' || 'Not valid number',
        order: (value) => value ? true: "Not in order"
     };

    private areValuesInOrder = true;
    get marks() {
        let ticks = 5
        let interval = this.rangeDiff / ticks;
        let marks: any = {};
        let minValue = this.minValue;
        let multiplier = 1;
        if (this.isInverted) {
            minValue = this.maxValue;
            multiplier = -1;
        }
        for (let i = 0; i <= ticks; i++) {
            marks[(this.minValue + interval * i).toString()] = (minValue + (interval * multiplier) * i).toString()
        }
        return marks
    }

    private textInputValues: number[] = [];

    private minValueInput = 0;
    private maxValueInput = 0;

    private minValue = 0;
    private maxValue = 100
    private inverted = false;
    private roundUpperLimit = false;

    get tooltipFormatter() {
        return (v: number) => `${this.inverted ? this.maxValue - v : v}`;
    }

    get rangeDiff() {
        return this.maxValue - this.minValue;
    }

    get interval() {
        return this.rangeDiff / 1000.0
    }

    get isInverted() {
        return this.inverted;
    }

    get direction() {
        return "ltr"
    }

    get scoringSparklineLabels() {
        if (this.scoringKeys) {
            let vals = this.scoringKeys.map(sk => sk.name)
            vals.splice(0, 0, "");
            return vals;
        }
        return [];
    }

    get scoringSparklineValues() {
        if (this.scoringRules) {
            let vals = this.scoringRules.map(sr => sr.upperLimit)
            vals.splice(0, 0, this.minValue);
            return vals;
        }
        return [];
    }
    get decisionId() {
    return decisionsModule.selectedDecisionId;
    }
    get activeViewpointId() {
    return viewpointModule.activeViewpointId;
    }

    get selectedViewpointIds() {
        return viewpointModule.selectedViewpointIds;
    }


    mounted() {
        if (this.values && this.values.length > 0) {
            this.maxValue = this.values.reduce((a, b) => Math.max(a, b), 0)
            this.minValue = this.values.reduce((a, b) => Math.min(a, b), 0)
        }

        if (this.scoringRules.length > 0) {
            if (this.scoringRules.filter(sr => sr.scoringFunction === 'MANUAL').length) {
                while (this.scoringRules.length !== 0) {
                    this.scoringRules.splice(0, 1)
                }
                this.initializeScoringRules();

            } else {
                this.maxValue = Math.max(...this.scoringRules.map(sr => sr.upperLimit))
                this.minValue = Math.min(...this.scoringRules.map(sr => sr.lowerLimitExclusive))
                // while (this.scoringKeys.length !== 0) {
                //     this.scoringKeys.splice(0, 1)
                // }
                for (let index = 0; index < this.scoringRules.length; index++) {
                    let scoringRule = this.scoringRules[index];
                //    this.scoringKeys.splice(this.scoringKeys.length, 0, scoringRule.scoringKey);
                    // this.sliderValues.splice(this.sliderValues.length, 0, [scoringRule.lowerLimitExclusive | 0, scoringRule.upperLimit]);
                    let inputValue = scoringRule.upperLimit;
                    if (scoringRule.inverted) {
                        this.inverted = true;
                        inputValue = this.maxValue - inputValue;
                    }

                    if (scoringRule.roundUpperLimit) {
                        this.roundUpperLimit = true;
                    }
                    this.textInputValues.splice(this.textInputValues.length, 0, inputValue);
                }
            }
        } else {
            this.initializeScoringRules()
        }
        this.minValueInput = this.minValue;
        this.maxValueInput = this.maxValue;
        this.getChartData();

    }

    private initializeScoringRules() {
        let interval = (this.maxValue - this.minValue) / this.scoringKeys.length
        for (let index = 0; index < this.scoringKeys.length; index++) {
            let upperLimit;
            let lowerLimitExclusive
            if (index === 0) {
                upperLimit = this.maxValue;
                lowerLimitExclusive = this.maxValue - interval;
            } else if (index === this.scoringKeys.length - 1) {
                upperLimit = this.minValue + interval;
                lowerLimitExclusive = this.minValue;
            } else {
                upperLimit = this.maxValue - (interval * (index))
                lowerLimitExclusive = this.maxValue - (interval * (index + 1))
            }
            // this.sliderValues.splice(this.sliderValues.length, 0, [lowerLimitExclusive, upperLimit])
            let inputValue = upperLimit;
            if (this.isInverted) {
                inputValue = this.maxValue - inputValue;
            }
            this.textInputValues.splice(this.textInputValues.length, 0, inputValue);
            let scoringRule = {
                upperLimit: upperLimit,
                lowerLimitExclusive: lowerLimitExclusive,
                inverted: this.isInverted,
                scoringFunction: 'LINEAR',
                scoringKey: this.scoringKeys[index]
            }
            this.scoringRules.splice(this.scoringRules.length, 0, scoringRule);
        }
    }

    /**
     * Updates various values based on the range values changing
     */
    private submitRangeChange() {
        if (this.minValueInput > this.maxValueInput) {
            //Invalid, min cannot be larger than max
            this.minValueInput = this.minValue;
            this.maxValueInput = this.maxValue;
        } else {
            this.maxValue = this.maxValueInput;
            this.minValue = this.minValueInput
            if (this.scoringRules.length > 0 && this.scoringRules[0].upperLimit < this.maxValue) {
                //Max value is larger than the largest scoring rule upper limit, update it
               this.textInputValues[0] = this.maxValue;
                this.updateScoringRules();
            } else if (this.scoringRules.length > 0 && this.scoringRules[this.scoringRules.length - 1].lowerLimitExclusive > this.minValue) {
                //Min value is smaller than the smallest scoring rule lower limit, update it
                // this.sliderValues[this.sliderValues.length - 1].splice(0, 1, this.minValue);
               this.textInputValues[this.textInputValues.length-1] = this.minValue
                this.updateScoringRules();
            } else if ((this.scoringRules.length > 0 && this.scoringRules[this.scoringRules.length - 1].upperLimit < this.minValue)
                || (this.scoringRules.length > 0 && this.scoringRules[0].lowerLimitExclusive > this.maxValue)) {
                // The user increased the lower limit really far, instead of trying to fix it all, just reinitialize
                // The user decreased the max limit really far, instead of trying to fix it all, just reinitialize
                while (this.scoringRules.length !== 0) {
                    this.scoringRules.splice(0, 1)
                }
        //        this.sliderValues = [];
                this.textInputValues = [];
                this.initializeScoringRules();
            }
        }
    }

    // private updateSliderValue(value: any, sliderIndex: number) {
    //     if (value[1] > this.sliderValues[sliderIndex - 1][1]) {
    //         this.sliderValues[sliderIndex].splice(1, 1, this.sliderValues[sliderIndex - 1][1] - this.interval)
    //         this.sliderValues[sliderIndex - 1].splice(0, 1, this.sliderValues[sliderIndex - 1][1] - this.interval)
    //     } else {
    //         this.sliderValues[sliderIndex].splice(1, 1, value[1])
    //         this.sliderValues[sliderIndex - 1].splice(0, 1, value[1])
    //     }

    //     if (this.isInverted) {
    //         this.textInputValues[sliderIndex] = this.maxValue - value[1];
    //     } else {
    //         this.textInputValues[sliderIndex] = value[1];
    //     }
    // }

    private changeTextInputField(index: number) {
        //Old slider values - leaving for time being but can delete later

        // if (!this.textInputValues[index]) {
        //     this.textInputValues[index] = this.sliderValues[index][1]
        //     if (this.isInverted) {
        //         this.textInputValues[index] = this.maxValue - this.textInputValues[index]
        //     }
        // }

        // if (!this.isInverted && this.textInputValues[index] < this.sliderValues[index][0]) {
        //     this.textInputValues[index] = this.sliderValues[index][0]
        // } else if (this.isInverted && this.textInputValues[index] > this.maxValue - this.sliderValues[index][0]) {
        //     this.textInputValues[index] = this.maxValue - this.sliderValues[index][0]
        // }

        // if (this.isInverted) {
        //     this.sliderValues[index][1] = this.maxValue - this.textInputValues[index];
        // } else {
        //     this.sliderValues[index][1] = this.textInputValues[index];
        // }
        let tempAreValuesInOrder = true;
        if(this.inverted) {
            for(let i = 0; i< this.textInputValues.length-1; i++) {
                if(this.textInputValues[i] > this.textInputValues[i+1]) {
                    tempAreValuesInOrder = false;
                }
            }
        } else {
            for(let i = 0; i< this.textInputValues.length-1; i++) {
                if(this.textInputValues[i] < this.textInputValues[i+1])
                    tempAreValuesInOrder = false;
            }
        }
            this.areValuesInOrder = tempAreValuesInOrder;
//        this.updateSliderValue(this.sliderValues[index], index);
        if(this.scoringRules.length === 0) {
            this.initializeScoringRules()
        }
        this.updateScoringRules()
    }

    private updateScoringRules() {
        for (let index = 0; index < this.scoringRules.length; index++) {
            console.log(this.scoringRules)
            Vue.set(this.scoringRules[index], 'upperLimit', this.convertToScoringRuleValue(this.textInputValues[index]));
            if (index !== this.scoringRules.length - 1) {
                Vue.set(this.scoringRules[index], 'lowerLimitExclusive', this.convertToScoringRuleValue(this.textInputValues[index + 1]));
            } else {
                Vue.set(this.scoringRules[index], 'lowerLimitExclusive', this.minValue);
            }
            Vue.set(this.scoringRules[index], 'inverted', this.isInverted);
            Vue.set(this.scoringRules[index], 'roundUpperLimit', this.roundUpperLimit);
        }
    }

    private invertedChanged() {
        this.updateScoringRules();
        for (let index in this.textInputValues) {
            this.textInputValues[index] = this.maxValue - this.textInputValues[index]
        }
    }

    private convertToScoringRuleValue(value: number) {
        // if (this.isInverted) {
        //     return (this.maxValue + this.minValue) - value
        // } else {
        return value;
        // }
    }

    private updateTextFields() {
        for(let i = 0; i < this.scoringKeys.length; i++) {
            if(this.textInputValues[i] === undefined) {
                this.textInputValues[i] = (this.textInputValues[i-1] - this.minValue) / 2
            }
        }
        this.updateScoringRules()
    }
    

    private async getChartData() {
    console.log("inside getChartData! calling getHistogramFactorData", this.factorId)
    try {
        if (this.factorId !== '') {
            const factor = this.factors[this.factorId];
            const res = await getModule(Scoring).getHistogramFactorData({numeric: true, decisionId:this.decisionId, viewpointId: this.activeViewpointId, viewpointIds:this.selectedViewpointIds, factorId:this.factorId, factorParentId:factor.id}); 
            console.log("WHY not working", res)
            
            if (Object.keys(res).length > 0) {
                this.chartData = res  //[this.activeViewpointId]
                console.log("Received chart data in linearScoringDefinitionRuleCreator.vue", this.chartData )
            }
        }
    } catch (error) {
        console.log("ERROR", error);
    }
    return this.chartData
    }

    @Watch('scoringKeys', {deep:true})
    private onWatchKeys(newVal: [], oldVal: []){
        if(newVal.length != this.scoringRules.length) {
            //this.updateTextFields()
            this.textInputValues = [];
        }
        
    }

    @Watch('tab')
    private onChangeTab(){
        if(this.tab === 1 && this.scoringRules.length === 0){
            this.initializeScoringRules()
        }
    }
    


}
